import { OrganizationUnitShiftConfig } from '@scheduling/graphql/types';
import { type DatetimeType } from '@common/services/datetime';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateOrganizationUnitShiftConfigsMutationCgResponse,
  CreateOrganizationUnitShiftConfigsMutationVariables,
  DeleteOrganizationUnitShiftConfigMutationCgResponse,
  DeleteOrganizationUnitShiftConfigMutationVariables,
  UpdateOrganizationUnitShiftConfigMutationCgResponse,
  UpdateOrganizationUnitShiftConfigMutationVariables,
} from '@common/graphql/schema';

export const CreateOrganizationUnitShiftConfigs: TypedDocumentNode<
  CreateOrganizationUnitShiftConfigsMutationCgResponse,
  CreateOrganizationUnitShiftConfigsMutationVariables
> = gql`
  mutation CreateOrganizationUnitShiftConfigs(
    $input: CreateOrganizationUnitShiftConfigsInput!
  ) {
    createOrganizationUnitShiftConfigs(input: $input) {
      organizationUnitShiftConfigs {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export const UpdateOrganizationUnitShiftConfig: TypedDocumentNode<
  UpdateOrganizationUnitShiftConfigMutationCgResponse,
  UpdateOrganizationUnitShiftConfigMutationVariables
> = gql`
  mutation UpdateOrganizationUnitShiftConfig(
    $id: ID!
    $input: UpdateOrganizationUnitShiftConfigInput!
  ) {
    updateOrganizationUnitShiftConfig(id: $id, input: $input) {
      organizationUnitShiftConfigs {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export const DeleteOrganizationUnitShiftConfig: TypedDocumentNode<
  DeleteOrganizationUnitShiftConfigMutationCgResponse,
  DeleteOrganizationUnitShiftConfigMutationVariables
> = gql`
  mutation DeleteOrganizationUnitShiftConfig($id: ID!) {
    deleteOrganizationUnitShiftConfig(id: $id) {
      organizationUnitShiftConfig {
        id
        startTime
        endTime
        duration
        role {
          id
          abbreviation
        }
      }
    }
  }
`;

export type CreateOrganizationUnitShiftConfigsVariables = {
  input: {
    organizationUnitId: string;
    roleIds?: string[];
    startTime: DatetimeType;
    endTime: DatetimeType;
    workloadStartTime?: DatetimeType;
    workloadEndTime?: DatetimeType;
    lunchBreakMinLength?: DatetimeType;
    lunchBreakMaxLength?: DatetimeType;
    lunchBreakDeductionDefault?: DatetimeType;
    workforceGroupIds?: string[];
  };
};

export type CreateOrganizationUnitShiftConfigsResponse = {
  createOrganizationUnitShiftConfigs: OrganizationUnitShiftConfig[];
};

export type UpdateOrganizationUnitShiftConfigVariables = {
  id: string;
  input: {
    organizationUnitId: string;
    startTime: DatetimeType;
    endTime: DatetimeType;
    workloadStartTime?: DatetimeType;
    workloadEndTime?: DatetimeType;
    lunchBreakMinLength?: DatetimeType;
    lunchBreakMaxLength?: DatetimeType;
    lunchBreakDeductionDefault?: DatetimeType;
    roleIds?: string[];
    workforceGroupIds?: string[];
  };
};

export type UpdateOrganizationUnitShiftConfigResponse = {
  updateOrganizationUnitShiftConfig: OrganizationUnitShiftConfig[];
};

export type DeleteOrganizationUnitShiftConfigVariables = {
  id: string;
};

export type DeleteOrganizationUnitShiftConfigResponse = {
  deleteOrganizationUnitShiftConfig: OrganizationUnitShiftConfig;
};
